import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { supabase } from "./lib/supabase";
import CertificationSearch from "./CertificationSearch";

export default function CertificationSearchPortal(){
 const founderPreview=new URLSearchParams(window.location.search).has("founder");
 const weldToken=new URLSearchParams(window.location.search).has("weld");
 const [header,setHeader]=useState<HTMLElement|null>(null),[companyId,setCompanyId]=useState("");
 useEffect(()=>{
   if(founderPreview||weldToken)return;
   let cancelled=false;
   const findHeader=()=>{const node=document.querySelector<HTMLElement>(".workspace>header");if(node&&!cancelled)setHeader(node)};
   findHeader();const observer=new MutationObserver(findHeader);observer.observe(document.body,{childList:true,subtree:true});
   supabase.from("company_members").select("company_id").limit(1).maybeSingle().then(({data})=>{if(!cancelled&&data?.company_id)setCompanyId(data.company_id)});
   return()=>{cancelled=true;observer.disconnect()};
 },[founderPreview,weldToken]);
 if(!header||!companyId)return null;
 return createPortal(<CertificationSearch companyId={companyId} onNavigate={(page)=>{
   const labels:Record<string,string>={qualifications:"Welder Qualifications",procedures:"WPS / WPDS Library",projects:"Projects",ncrs:"Non-Conformance Reports",inspections:"Inspection & Testing"};
   const label=labels[page];
   const button=Array.from(document.querySelectorAll<HTMLButtonElement>(".app-shell nav button")).find(x=>x.textContent?.includes(label));
   button?.click();
 }}/>,header);
}
